export const productsData = {
  // 男和紙混粗織斜紋5口袋寬版褲
  pomelo01: {
    name: '斗六嘉東老欉文旦 3公斤禮盒',
    number: 'xxxxxxxxxx001',
    price: '699',
    img: {
      white_bg: 'pomelo-package01.jpg',
      usage: '',
    },
    alt: '',
    href: 'https://shop.muji.tw/SalePage/Index/11043786',
  },
  pomelo02: {
    name: '斗六嘉東老欉文旦3公斤禮盒 2盒',
    number: 'xxxxxxxxxx002',
    price: '1,200',
    img: {
      white_bg: 'pomelo-package02.jpg',
      usage: '',
    },
    alt: '',
    href: 'https://shop.muji.tw/SalePage/Index/11043796',
  },
  pomelo03: {
    name: '斗六嘉東老欉文旦3公斤禮盒 4盒',
    number: 'xxxxxxxxxx003',
    price: '2,200',
    img: {
      white_bg: 'pomelo-package03.jpg',
      usage: '',
    },
    alt: '',
    href: 'https://shop.muji.tw/SalePage/Index/11043800',
  },
};

export const lineupData = [
  {
    id: 1,
    current_index: 0,
    no_chips: true,
    tag: '',
    items: ['pomelo01'],
  },
  {
    id: 2,
    current_index: 0,
    no_chips: true,
    tag: '',
    items: ['pomelo02'],
  },
  {
    id: 3,
    current_index: 0,
    no_chips: true,
    tag: '',
    items: ['pomelo03'],
  },
];

export const reportData = [
  {
    id: 1,
    link: 'https://www.muji.tw/tw/feature/25aw/Lookbook-winter/',
    img: 'story01.jpg',
    text: '無印良品 2025｜冬季服飾穿搭',
  },
  {
    id: 2,
    link: 'https://www.muji.tw/tw/feature/24ss/storage-supplies/',
    img: 'story02.jpg',
    text: '無印良品的收納用品',
  },
  {
    id: 3,
    link: 'https://www.muji.tw/tw/feature/25aw/skincare/',
    img: 'story03.jpg',
    text: '臉部保養系列',
  },
  {
    id: 4,
    link: 'https://www.muji.tw/tw/feature/fragrance/',
    img: 'story04.jpg',
    text: '香氣・空間香氛',
  },
  {
    id: 5,
    link: 'https://www.muji.tw/tw/muji-market-golden/',
    img: 'story05.jpg',
    text: '黃金廊道',
  },
  {
    id: 6,
    link: 'https://www.muji.tw/tw/feature/25ss/muji-market-valencia/',
    img: 'story06.jpg',
    text: '晚崙西亞​橙',
  },
];
